import { FormControl, Grid, InputLabel } from '@mui/material';

import HierarchicalCategoryField from '../../HierarchicalMultiSelect/HierarchicalCategoryField';
import SOURCE_TYPE from '../../SourceCreate.constants';
import type { ConnectionInputSchema } from '../../SourceCreate.types';

type MultiLevelCategorySelectorProps = {
  selectedSourceTypeId: number;
  connectionInputSchema: ConnectionInputSchema | null;
  isResettingSourceType: boolean;
};

/**
 * MultiLevelCategorySelector renders hierarchical category selector for Google Workspace.
 * Google Workspace uses nested categories unlike flat categories in other sources.
 */
const MultiLevelCategorySelector = ({
  selectedSourceTypeId,
  connectionInputSchema,
  isResettingSourceType
}: MultiLevelCategorySelectorProps) => {
  if (isResettingSourceType) return null;
  if (selectedSourceTypeId !== SOURCE_TYPE.GOOGLE_WORKSPACE) return null;
  if (!connectionInputSchema?.show_categories) return null;

  return (
    <Grid size={{ xs: 12, sm: 12, md: 12 }}>
      <InputLabel htmlFor="device-name-input">
        Category
        {connectionInputSchema?.mandatory_categories && <span> *</span>}
      </InputLabel>
      <FormControl fullWidth>
        <HierarchicalCategoryField />
      </FormControl>
    </Grid>
  );
};

export default MultiLevelCategorySelector;
